module.exports = __webpack_public_path__ + "static/deng-xiaoping-and-the-transformation-of-china-f34a3398dab3072a96ec2a55cf126171.jpg";